import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {AuditTraceDTO} from '../../../shared/dto/AuditTraceDTO';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {AudittraceReportService} from '../../../shared/service/audittrace-report.service';
import {DateRangeDto} from '../../../shared/dto/DateRangeDto';
import swal, {default as Swal} from 'sweetalert2';

@Component({
  selector: 'app-audit-trace-details',
  templateUrl: './audit-trace-details.component.html',
  styleUrls: ['./audit-trace-details.component.scss']
})
export class AuditTraceDetailsComponent implements OnInit {

  public requestForm: FormGroup;
  public auditTraceDto: AuditTraceDTO[]=[];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  displayedColumns: string[] = ['id', 'activity', 'userName', 'page', 'task', 'userCategory', 'employeeId', 'applicantId', 'user','createdTime'];
  public printExcelSheet=false;

  constructor(private spinnerService: NgxUiLoaderService, private reportService: AudittraceReportService) { }

  ngOnInit() {
    this.requestForm = new FormGroup({
      dateTimeRange: new FormControl(null)
    });
    this.printExcelSheet=true;
  }

  onSubmitSearch(form: FormGroup){
    const dateRange = new DateRangeDto();
    dateRange.date=(form.value.dateTimeRange);
    this.loadSearchResult(dateRange);
  }

  loadSearchResult(dateRange: DateRangeDto): void {
    this.spinnerService.start();
    this.reportService.searchAuditTraceData(dateRange).subscribe(
      (data: AuditTraceDTO[]) =>{
        if (data.length > 0) {
          this.auditTraceDto = data;
          this.dataSource = new MatTableDataSource(this.auditTraceDto);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.printExcelSheet = false;
        }

      },
      (error) => {
        this.spinnerService.stop();
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        this.spinnerService.stop();

        if(this.auditTraceDto == null || this.auditTraceDto.length === 0){
          swal.fire('Sorry', 'No result found.', 'info');
        }
      }
    );
  }

  applyFilter(filterValue: string){
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }

  onClickReset(){
    this.requestForm.reset({
      dateTimeRange: [],
    });
    this.printExcelSheet = true;
  }

  printExcel(form: FormGroup){
    const dateRange = new DateRangeDto();
    dateRange.date=(form.value.dateTimeRange);

    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to print the excel?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.reportService.printExcelReport(dateRange);
      } else {
      }
    });
  }


  exportAsPDF(){
    this.spinnerService.start();
    this.reportService.exportAsPDF(this.auditTraceDto).subscribe(
      (data:any) =>{
        console.log("This Data " + data);
        const file = new Blob([data], {type:'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank");
      }, error => {
        this.spinnerService.stop();
        console.log(error);
      }
    );
    this.spinnerService.stop();
  }

  exportAsExcel() {
    this.spinnerService.start();
    this.reportService.exportAsExcel(this.auditTraceDto).subscribe(
      (data:any) =>{
        console.log("This Data " + data);
        const file = new Blob([data], {type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank");
      }, error => {
        this.spinnerService.stop();
        console.log(error);
      }
    );
    this.spinnerService.stop();
  }
}
